var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { FULFILLMENT_TYPE } from '../../constants/status';
import { pushEventInfo, setPageDetails, setPostOrderInfo } from '../analytics';
// 1.1.6 - Cancel Request Overlay - Post Remorse
export var trackRequestCancelOverlay = function () {
    pushEventInfo({
        category: { primaryCategory: 'overlay' },
        eventInfo: { eventName: 'request cancellation drawer: post-remorse' },
    });
};
export var trackCancelButtonSubmission = function (_a) {
    var fulfillmentGroups = _a.fulfillmentGroups, transactionId = _a.transactionId;
    var itemsArray = [];
    fulfillmentGroups.map(function (el) {
        var _a;
        return (_a = el.lineItems) === null || _a === void 0 ? void 0 : _a.map(function (_a) {
            var description = _a.description, skuNumber = _a.skuNumber, omsId = _a.omsId, cancelledQuantity = _a.cancelledQuantity;
            return itemsArray.push({
                productInfo: {
                    productName: description,
                    sku: skuNumber === null || skuNumber === void 0 ? void 0 : skuNumber.toString(),
                    superSku: omsId ? omsId === null || omsId === void 0 ? void 0 : omsId.toString() : undefined,
                },
                quantity: cancelledQuantity === null || cancelledQuantity === void 0 ? void 0 : cancelledQuantity.toString(),
            });
        });
    });
    pushEventInfo({
        category: {
            primaryCategory: 'button submission',
        },
        eventInfo: {
            eventName: 'cancel request',
        },
        myAccount: {
            settings: 'cancel requested: post-remorse',
        },
        postOrder: {
            item: __assign({}, itemsArray),
            transactionID: transactionId === null || transactionId === void 0 ? void 0 : transactionId.toString(),
        },
    });
};
// 1.1.8 Successful Cancellation - post-remorse
export var trackPostRemorseCancelSuccess = function (_a) {
    var fulfillmentGroups = _a.fulfillmentGroups, transactionId = _a.transactionId;
    setPageDetails({
        pageInfo: {
            pageName: 'account>purchase history>order details',
            pageType: 'maml:orders',
            pageLoadEvent: 'cancel success',
        },
        category: {
            primaryCategory: 'account',
            subCategory1: 'account>purchase history',
            subCategory2: 'account>purchase history>order details',
        },
    });
    var itemsArray = [];
    // item should be an array of objects, one object for each item
    fulfillmentGroups.map(function (_a) {
        var lineItems = _a.lineItems, fulfillmentType = _a.fulfillmentType, storePickup = _a.storePickup;
        return lineItems === null || lineItems === void 0 ? void 0 : lineItems.map(function (_a) {
            var _b, _c, _d;
            var description = _a.description, skuNumber = _a.skuNumber, omsId = _a.omsId, cancelledQuantity = _a.cancelledQuantity, unitPrice = _a.unitPrice;
            return itemsArray.push({
                fulfillment: {
                    method: fulfillmentType,
                    store: fulfillmentType === 'BuyOnlineShipToStore'
                        ? (_b = storePickup === null || storePickup === void 0 ? void 0 : storePickup.store) === null || _b === void 0 ? void 0 : _b.number
                        : undefined,
                    zip: fulfillmentType === 'BuyOnlineShipToStore'
                        ? (_d = (_c = storePickup === null || storePickup === void 0 ? void 0 : storePickup.store) === null || _c === void 0 ? void 0 : _c.address) === null || _d === void 0 ? void 0 : _d.zipCode
                        : undefined,
                },
                productInfo: {
                    productName: description,
                    sku: skuNumber === null || skuNumber === void 0 ? void 0 : skuNumber.toString(),
                    superSku: omsId ? omsId === null || omsId === void 0 ? void 0 : omsId.toString() : undefined,
                },
                quantity: cancelledQuantity === null || cancelledQuantity === void 0 ? void 0 : cancelledQuantity.toString(),
                price: {
                    basePrice: ((cancelledQuantity !== null && cancelledQuantity !== void 0 ? cancelledQuantity : 0) * (unitPrice !== null && unitPrice !== void 0 ? unitPrice : 0)).toFixed(2),
                },
            });
        });
    });
    setPostOrderInfo(__assign(__assign({}, itemsArray), { transactionID: transactionId === null || transactionId === void 0 ? void 0 : transactionId.toString() }));
};
export var generateCancelSuccessTrackingData = function (_a) {
    var fulfillmentGroups = _a.fulfillmentGroups, transactionId = _a.transactionId;
    setPageDetails({
        pageInfo: {
            pageName: 'account>purchase history>order details',
            pageType: 'maml:orders',
            pageLoadEvent: 'cancel success',
        },
        category: {
            primaryCategory: 'account',
            subCategory1: 'account>purchase history',
            subCategory2: 'account>purchase history>order details',
        },
    });
    var itemsArray = [];
    fulfillmentGroups.forEach(function (_a) {
        var lineItems = _a.lineItems, fulfillmentType = _a.fulfillmentType, storePickup = _a.storePickup;
        lineItems === null || lineItems === void 0 ? void 0 : lineItems.forEach(function (_a) {
            var _b, _c, _d, _e;
            var description = _a.description, skuNumber = _a.skuNumber, omsId = _a.omsId, cancelledQuantity = _a.cancelledQuantity, unitPrice = _a.unitPrice;
            var fulfillmentTypeMappings = (((_b = Object.entries(FULFILLMENT_TYPE).find(function (_a) {
                var _key = _a[0], value = _a[1];
                return value === fulfillmentType;
            })) === null || _b === void 0 ? void 0 : _b[0]) ||
                '');
            itemsArray.push({
                fulfillment: {
                    method: fulfillmentTypeMappings,
                    store: fulfillmentType === 'BuyOnlineShipToStore'
                        ? (_c = storePickup === null || storePickup === void 0 ? void 0 : storePickup.store) === null || _c === void 0 ? void 0 : _c.number
                        : undefined,
                    zip: fulfillmentType === 'BuyOnlineShipToStore'
                        ? (_e = (_d = storePickup === null || storePickup === void 0 ? void 0 : storePickup.store) === null || _d === void 0 ? void 0 : _d.address) === null || _e === void 0 ? void 0 : _e.zipCode
                        : undefined,
                },
                productInfo: {
                    productName: description,
                    sku: skuNumber === null || skuNumber === void 0 ? void 0 : skuNumber.toString(),
                    superSku: omsId ? omsId === null || omsId === void 0 ? void 0 : omsId.toString() : undefined,
                },
                quantity: cancelledQuantity === null || cancelledQuantity === void 0 ? void 0 : cancelledQuantity.toString(),
                price: {
                    basePrice: ((cancelledQuantity !== null && cancelledQuantity !== void 0 ? cancelledQuantity : 0) * (unitPrice !== null && unitPrice !== void 0 ? unitPrice : 0)).toFixed(2),
                },
            });
        });
    });
    var orderStatus = 'cancelled';
    setPostOrderInfo(itemsArray, transactionId === null || transactionId === void 0 ? void 0 : transactionId.toString(), orderStatus);
};
// 1.1.9 Partial Cancel - Post-Remorse
export var trackPostRemorsePartialCancel = function (_a) {
    var fulfillmentGroups = _a.fulfillmentGroups, orderNumber = _a.orderNumber;
    setPageDetails({
        pageInfo: {
            pageName: 'account>purchase history>order details',
            pageType: 'maml:orders',
            pageLoadEvent: 'partial cancellation',
        },
        category: {
            primaryCategory: 'account',
            subCategory1: 'account>purchase history',
            subCategory2: 'account>purchase history>order details',
        },
        error: {
            type: 'advisory',
            displayType: 'inline',
            pageSection: 'partial cancellation',
            message: "'Items in Order # ".concat(orderNumber, " Couldn't be canceled'"),
            code: 'n/a',
        },
    });
    var itemsArray = [];
    fulfillmentGroups.map(function (_a) {
        var lineItems = _a.lineItems, fulfillmentType = _a.fulfillmentType, storePickup = _a.storePickup;
        return lineItems === null || lineItems === void 0 ? void 0 : lineItems.map(function (_a) {
            var _b, _c, _d;
            var cancelledQuantity = _a.cancelledQuantity, description = _a.description, skuNumber = _a.skuNumber, omsId = _a.omsId, unitPrice = _a.unitPrice;
            return itemsArray.push({
                item: {
                    fulfillment: {
                        method: fulfillmentType,
                        store: fulfillmentType === 'BuyOnlineShipToStore'
                            ? (_b = storePickup === null || storePickup === void 0 ? void 0 : storePickup.store) === null || _b === void 0 ? void 0 : _b.number
                            : undefined,
                        zip: fulfillmentType === 'BuyOnlineShipToStore'
                            ? (_d = (_c = storePickup === null || storePickup === void 0 ? void 0 : storePickup.store) === null || _c === void 0 ? void 0 : _c.address) === null || _d === void 0 ? void 0 : _d.zipCode
                            : undefined,
                    },
                    price: {
                        basePrice: ((cancelledQuantity !== null && cancelledQuantity !== void 0 ? cancelledQuantity : 0) * (unitPrice !== null && unitPrice !== void 0 ? unitPrice : 0)).toFixed(2),
                    },
                    productInfo: {
                        productName: description,
                        sku: skuNumber === null || skuNumber === void 0 ? void 0 : skuNumber.toString(),
                        superSku: omsId ? omsId === null || omsId === void 0 ? void 0 : omsId.toString() : undefined,
                    },
                    quantity: cancelledQuantity,
                },
            });
        });
    });
    setPostOrderInfo(itemsArray);
};
// 1.1.10 Unsuccessful Cancellation - Post-Remorse
export var trackPostRemorseCancelFail = function (errorMessage) {
    pushEventInfo({
        category: { primaryCategory: 'error' },
        eventInfo: {
            eventName: 'post page error',
            error: [
                {
                    type: 'advisory',
                    displayType: 'inline',
                    pageSection: 'order details',
                    message: "".concat(errorMessage),
                    code: 'n/a',
                },
            ],
        },
    });
};
export var trackCancelItemsButtonClick = function () {
    pushEventInfo({
        category: {
            primaryCategory: 'button submission',
        },
        eventInfo: {
            eventName: 'my account settings',
        },
        myAccount: {
            settings: 'purchase history: order details: cancel items button',
        },
    });
};
export var trackCancelItemsButtonDisplay = function () {
    pushEventInfo({
        category: {
            primaryCategory: 'button submission',
        },
        eventInfo: {
            eventName: 'my account settings',
        },
        myAccount: {
            settings: 'purchase history: order details: cancel items button displayed',
        },
    });
};
export var trackConfirmItemsToCancelClick = function (cancelReason) {
    pushEventInfo({
        category: {
            primaryCategory: 'button submission',
        },
        eventInfo: {
            eventName: 'my account settings',
        },
        myAccount: {
            settings: 'purchase history: order details: confirm items to cancel button',
        },
        return: {
            item: [cancelReason],
        },
    });
};
export var trackMACancelItemsConfirmation = function () {
    setPageDetails({
        pageInfo: {
            pageName: 'account>purchase history>order details>cancel items',
            pageType: 'maml: cancel items',
        },
        category: {
            primaryCategory: 'account',
            subCategory1: 'account>purchase history',
            subCategory2: 'account>purchase history>order details>cancel items',
        },
    });
};
export var trackCancelItemsSysError = function (errorMessage, errorCode) {
    if (errorCode === void 0) { errorCode = 'n/a'; }
    pushEventInfo({
        category: { primaryCategory: 'error' },
        eventInfo: {
            eventName: 'post page error',
            error: [
                {
                    type: 'error',
                    displayType: 'inline',
                    pageSection: 'order details: cancel this return overlay',
                    message: "".concat(errorMessage),
                    code: errorCode,
                },
            ],
        },
    });
};
